// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CreateProjectRequestContainer_wrap__2cpeL","title":"CreateProjectRequestContainer_title__382vu"};